import { useConnectionStatus } from '@platewell/query';

/**
 * Stands in for an empty list on a device that has not yet received the household. Without
 * it a first sign-in says "no recipes" over a book that is still arriving.
 */
export function FirstSyncEmpty() {
  const { status } = useConnectionStatus();

  return (
    <div className="empty" role="status">
      <h2>Syncing your recipes…</h2>
      <p className="hint">
        {status === 'offline'
          ? 'Connect to the internet to bring your recipes onto this device.'
          : 'Bringing your recipes onto this device. This only happens the first time.'}
      </p>
    </div>
  );
}
